/* eslint-disable sonarjs/no-duplicate-string */
import dayjs from 'dayjs';
import { z } from 'zod';

// Элемент результата поиска новостей
export const searchNewsSchema = z
  .object({
    type: z.literal('news').optional(),
    id: z.coerce.number(),
    title: z.string(),
    content_type: z.string().optional(),
    source: z.url().nullable().optional(),
    published_at: z.string(),
    quote: z.string().nullable().optional(),
    combined_score: z.number().optional(),
    importance_score: z.number().optional(),
  })
  .transform((raw) => ({
    id: raw.id,
    title: raw.title,
    description: (raw.quote ?? '').trim() || raw.title,
    source: raw.source ?? null,
    createdAt: dayjs(raw.published_at).format('DD MMMM YYYY'),
    updatedAt: dayjs(raw.published_at).format('DD MMMM YYYY'),
    publishDate: dayjs(raw.published_at).format('DD MMMM YYYY'),
    combinedScore: raw.combined_score,
    importanceScore: raw.importance_score,
  }));

export type SearchNewsEntityApi = z.input<typeof searchNewsSchema>;
export type SearchNewsEntity = z.infer<typeof searchNewsSchema>;

export const searchNewsResponseSchema = z.object({
  items: z.array(searchNewsSchema),
  total: z.number(),
});

export type SearchNewsResponseApi = z.input<typeof searchNewsResponseSchema>;
export type SearchNewsResponse = z.infer<typeof searchNewsResponseSchema>;

export const searchNewsPaginatorSchema = z.object({
  total_count: z.number(),
  page_size: z.number(),
  page: z.number(),
});

export type SearchNewsPaginatorApi = z.input<typeof searchNewsPaginatorSchema>;
export type SearchNewsPaginator = z.infer<typeof searchNewsPaginatorSchema>;

export const searchNewsFullResponseSchema = z.object({
  items: z.array(searchNewsSchema),
  total: z.number(),
  paginator: searchNewsPaginatorSchema,
});

export type SearchNewsFullResponseApi = z.input<typeof searchNewsFullResponseSchema>;
export type SearchNewsFullResponse = z.infer<typeof searchNewsFullResponseSchema>;
